export default __webpack_public_path__ + "static/Press_Release_Inc_5000-2024-417dc9a25a9f83a6144d2e8e574b15b0.pdf";